module.exports = __webpack_public_path__ + "img/house3.caab9ade.png";